import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/company/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/company/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/company/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/company/submit',
    method: 'post',
    data: row
  })
}

export const companyModelExcel = (params) => {
  return request({
    url: '/user/company/model',
    method: 'get',
    responseType: 'blob',
    params: {
      ...params
    }
  })
}

export const isStart = (data) => {
  return request({
    url: '/user/company/isStart',
    method: 'post',
    data: data
  })
}
export const isSend = (data) => {
  return request({
    url: '/user/company/isSend',
    method: 'post',
    data: data
  })
}
export const handleStatus = (data) => {
  return request({
    url: '/user/company/start',
    method: 'post',
    data: data
  })
}
export const batchIsStart = (ids, status) => {
  return request({
    url: '/user/company/batchIsStart',
    method: 'post',
    params: {
      ids,
      status
    }
  })
}
export const isValidTin = (tin, id) => {
  return request({
    url: '/user/company/check/tin',
    method: 'get',
    params: {
      tin,
      id
    }
  })
}

